module.exports = __webpack_public_path__ + "img/ethereum.094d3b83.svg";